import { createAsyncThunk } from '@reduxjs/toolkit'
import { PRODUCT_URLS } from '../../../../configs/api'
import { AxiosService } from '../../../../services/api'
import { createThunkName } from '../../../../utils/createThunkname'
import {
  CreateProductDto,
  DeleteProductDto,
  GetAllProductsQueryParams,
  GetAllProductsResponse,
  GetProductByIdResponse,
  UpdateProductDto,
  UpdateProductOrderDto
} from './types'

const PREFIX = 'product'

export const ProductService = {
  getAllProductsAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getAllProducts'),
    async (queryParams: GetAllProductsQueryParams) => {
      try {
        const result = await AxiosService.get<GetAllProductsResponse>(PRODUCT_URLS.getAllProducts, {
          params: queryParams
        })
        return result.data
      } catch (error) {
        throw error
      }
    }
  ),
  getProductByIdAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getProductById'), async (productId: string) => {
    try {
      const result = await AxiosService.get<GetProductByIdResponse>(PRODUCT_URLS.getProductById(productId))
      return result.data
    } catch (error) {
      throw error
    }
  }),
  createProductAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'createProduct'), async (dto: CreateProductDto) => {
    try {
      await AxiosService.post(PRODUCT_URLS.createProduct, dto)
    } catch (error) {
      throw error
    }
  }),
  updateProductAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'updateProduct'), async (dto: UpdateProductDto) => {
    try {
      await AxiosService.put(PRODUCT_URLS.updateProduct, dto)
    } catch (error) {
      throw error
    }
  }),
  deleteProductAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'deleteProduct'), async (dto: DeleteProductDto) => {
    try {
      await AxiosService.post(PRODUCT_URLS.deleteProduct, dto)
    } catch (error) {
      throw error
    }
  }),
  updateProductOrderAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'updateProductOrder'),
    async (dto: UpdateProductOrderDto) => {
      try {
        await AxiosService.put(PRODUCT_URLS.updateProductOrder, dto)
      } catch (error) {
        throw error
      }
    }
  )
}
